/**
 * Frontend JavaScript — Entry Point
 *
 * This file is the main entry point for front-end scripts.
 * wp-scripts bundles and minifies this automatically.
 *
 * CSS imports are extracted to frontend.css by wp-scripts.
 */

$ = jQuery;

// ── Styles ──────────────────────────────────────
import '../scss/frontend.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../scss/slider.scss';

// ── Modules ─────────────────────────────────────
// Navigation: comportement mobile géré nativement par le bloc Navigation FSE.
// Le module custom a été retiré pour rester aligné avec le markup core.
import { initOllieOffCanvas, initCustomMobileMenuClose, initLinguiseAccessibility } from './modules/navigation';
import { initScrollEffects } from './modules/scroll';
import { initLazyModules } from './modules/lazy-loader';
import { initGalleryLightboxes } from './modules/gallery-lightbox';
import { initHighfiveDynamicSliders } from './slider';
import { initAjaxSearchLiteLabel } from './modules/ajax-search-label';
import { initGfClearFieldErrors } from './modules/gf-clear-field-errors';
import { initGfNestConditionalFields } from './modules/gf-nest-conditional-fields';
import { initGfSaveSuccessNotice } from './modules/gf-save-success-notice';
import { initGfFileLoadedNotice } from './modules/gf-file-loaded-notice';

// ── Init ────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
    initOllieOffCanvas();
    initCustomMobileMenuClose();
    initLinguiseAccessibility();
    initScrollEffects();
    initLazyModules();
    initHighfiveDynamicSliders();
    initGalleryLightboxes();
    initAjaxSearchLiteLabel();
    initGfClearFieldErrors();
    initGfNestConditionalFields();
    initGfSaveSuccessNotice();
    initGfFileLoadedNotice();
});

